"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsStats = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_stats_1 = require("../../request/user-details-stats");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsStats = (referenceDate, splitByContractTypes) => {
    const { workspace, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-stats',
        requestor: async () => await (0, user_details_stats_1.requestUserDetailsStats)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
            referenceDate,
            splitByContractTypes,
        }),
        reducer: (data) => dispatch((0, user_details_1.setUserRoleStats)(data?.stats)),
        selector: (state) => state.userDetails.stats,
        listenDeps: [workspace?.id, userId, referenceDate, splitByContractTypes],
    });
    return data;
};
exports.useUserDetailsStats = useUserDetailsStats;
